const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_reaction: 'e904',
  addboost: 'e905',
  addmember_filled: 'e906',
  adduser: 'e907',
  admin: 'e908',
  ads: 'e909',
  align_center: 'e90a',
  align_left: 'e90b',
  align_right: 'e90c',
  animals: 'e90d',
  animations: 'e90e',
  app_expand: 'e90f',
  app_shrink: 'e910',
  archive: 'e911',
  arrow_down: 'e912',
  arrow_next: 'e913',
  arrow_prev: 'e914',
  arrowcircle: 'e915',
  arrowhead: 'e916',
  attach: 'e917',
  audio_repeat: 'e918',
  audio_repeat_single: 'e919',
  author_hidden: 'e91a',
  avatarnext: 'e91b',
  avatarprevious: 'e91c',
  aversion: 'e91d',
  back: 'e91e',
  binfilled: 'e91f',
  bold: 'e920',
  bomb: 'e921',
  boost: 'e922',
  boostcircle: 'e923',
  bot_filled: 'e924',
  botcom: 'e925',
  bots: 'e926',
  brightness: 'e927',
  brush: 'e928',
  bubblereply: 'e929',
  bug: 'e92a',
  calendar: 'e92b',
  calendarfilter: 'e92c',
  camera: 'e92d',
  cameraadd: 'e92e',
  captiondown: 'e92f',
  captionup: 'e930',
  car: 'e931',
  card: 'e932',
  card_outline: 'e933',
  cash_circle: 'e934',
  channel: 'e935',
  channel_filled: 'e936',
  channelviews: 'e937',
  chatspinned: 'e938',
  chatsplaceholder: 'e939',
  check1: 'e93a',
  checkbox: 'e93b',
  checkboxblock: 'e93c',
  checkboxempty: 'e93d',
  checkboxon: 'e93e',
  checklist_add: 'e93f',
  checklist_done: 'e940',
  checklist_undone: 'e941',
  checkretract: 'e942',
  checkround: 'e943',
  checkround_filled: 'e944',
  clock: 'e945',
  close: 'e946',
  clouddownload: 'e947',
  collapse: 'e948',
  colorize: 'e949',
  comments: 'e94a',
  commentssticker: 'e94b',
  contrast: 'e94c',
  copy: 'e94d',
  crop: 'e94e',
  cross: 'e94f',
  crossgif: 'e950',
  crossround: 'e951',
  crossstar: 'e952',
  crown: 'e953',
  darkmode: 'e954',
  data: 'e955',
  delete: 'e956',
  delete_filled: 'e957',
  deletedaccount: 'e958',
  deleteleft: 'e959',
  deleteuser: 'e95a',
  devices: 'e95b',
  document: 'e95c',
  down: 'e95d',
  download: 'e95e',
  dragfiles: 'e95f',
  dragmedia: 'e960',
  eats: 'e961',
  edit: 'e962',
  email: 'e963',
  endcall_filled: 'e964',
  enhance: 'e965',
  enter: 'e966',
  equalizer: 'e967',
  expand: 'e968',
  eye: 'e969',
  eye1: 'e96a',
  eye2: 'e96b',
  eyecross_outline: 'e96c',
  factcheck: 'e96d',
  fade: 'e96e',
  fast_forward: 'e96f',
  fast_rewind: 'e970',
  favourites: 'e971',
  flag: 'e972',
  flip: 'e973',
  flip_image_horizontal: 'e974',
  folder: 'e975',
  fontframe: 'e976',
  fontframe_bg: 'e977',
  fontframe_outline: 'e978',
  fontsize: 'e979',
  forward: 'e97a',
  forward_filled: 'e97b',
  free_transform: 'e97c',
  fullscreen: 'e97d',
  gc_microphone: 'e97e',
  gc_microphoneoff: 'e97f',
  gem: 'e980',
  gem_exchange: 'e981',
  gem_transfer: 'e982',
  geometric_digit_0: 'e983',
  geometric_digit_1: 'e984',
  geometric_digit_2: 'e985',
  geometric_digit_3: 'e986',
  geometric_digit_4: 'e987',
  geometric_digit_5: 'e988',
  geometric_digit_6: 'e989',
  geometric_digit_7: 'e98a',
  geometric_digit_8: 'e98b',
  geometric_digit_9: 'e98c',
  geometric_dot: 'e98d',
  geometric_letter_x: 'e98e',
  gifs: 'e98f',
  gift: 'e990',
  gift_premium: 'e991',
  grain: 'e992',
  group: 'e993',
  group_filled: 'e994',
  groupmedia: 'e995',
  groupmediaoff: 'e996',
  hand: 'e997',
  help: 'e998',
  hide: 'e999',
  highlights: 'e99a',
  image: 'e99b',
  image_original: 'e99c',
  info: 'e99d',
  info2: 'e99e',
  italic: 'e99f',
  key: 'e9a0',
  keyboard: 'e9a1',
  lamp: 'e9a2',
  language: 'e9a3',
  largepause: 'e9a4',
  largeplay: 'e9a5',
  left: 'e9a6',
  limit_chat: 'e9a7',
  limit_chats: 'e9a8',
  limit_file: 'e9a9',
  limit_folders: 'e9aa',
  limit_link: 'e9ab',
  limit_pin: 'e9ac',
  link: 'e9ad',
  link_paid: 'e9ae',
  list: 'e9af',
  listscreenshare: 'e9b0',
  livelocation: 'e9b1',
  location: 'e9b2',
  lock: 'e9b3',
  lockoff: 'e9b4',
  loginlogodesktop: 'e9b5',
  loginlogomobile: 'e9b6',
  logout: 'e9b7',
  mac_command_key: 'e9b8',
  mediaspeed_empty: 'e9b9',
  mediaspoiler: 'e9ba',
  mediaspoileroff: 'e9bb',
  mention: 'e9bc',
  menu: 'e9bd',
  message: 'e9be',
  message_jump: 'e9bf',
  message_quote: 'e9c0',
  messageunread: 'e9c1',
  microphone: 'e9c2',
  microphone_crossed: 'e9c3',
  microphone_crossed_filled: 'e9c4',
  microphone_filled: 'e9c5',
  minus: 'e9c6',
  monospace: 'e9c7',
  more: 'e9c8',
  multistories: 'e9c9',
  mute: 'e9ca',
  muted: 'e9cb',
  mynotes: 'e9cc',
  newchannel: 'e9cd',
  newchannel_filled: 'e9ce',
  newchat_filled: 'e9cf',
  newgroup: 'e9d0',
  newgroup_filled: 'e9d1',
  newprivate: 'e9d2',
  newprivate_filled: 'e9d3',
  newtab: 'e9d4',
  next: 'e9d5',
  nochannel: 'e9d6',
  noncontacts: 'e9d7',
  nosound: 'e9d8',
  online: 'e9d9',
  passwordoff: 'e9da',
  pause: 'e9db',
  permissions: 'e9dc',
  person: 'e9dd',
  phone: 'e9de',
  phone_filled: 'e9df',
  pin: 'e9e0',
  pin2: 'e9e1',
  pinlist: 'e9e2',
  pinned_filled: 'e9e3',
  pinnedchat: 'e9e4',
  pip: 'e9e5',
  play: 'e9e6',
  playback_05: 'e9e7',
  playback_15: 'e9e8',
  playback_1x: 'e9e9',
  playback_2x: 'e9ea',
  plus: 'e9eb',
  plusround: 'e9ec',
  poll: 'e9ed',
  premium_addone: 'e9ee',
  premium_avatars: 'e9ef',
  premium_badge: 'e9f0',
  premium_colors: 'e9f1',
  premium_double: 'e9f2',
  premium_emoji: 'e9f3',
  premium_filesize: 'e9f4',
  premium_lastseen: 'e9f5',
  premium_limits: 'e9f6',
  premium_lock: 'e9f7',
  premium_management: 'e9f8',
  premium_noads: 'e9f9',
  premium_privacy: 'e9fa',
  premium_reactions: 'e9fb',
  premium_restrict: 'e9fc',
  premium_speed: 'e9fd',
  premium_status: 'e9fe',
  premium_stickers: 'e9ff',
  premium_tags: 'ea00',
  premium_transcription: 'ea01',
  premium_translate: 'ea02',
  premium_unlock: 'ea03',
  premium_wallpaper: 'ea04',
  previous: 'ea05',
  promote: 'ea06',
  quote: 'ea07',
  quote_outline: 'ea08',
  radiooff: 'ea09',
  radioon: 'ea0a',
  reactions: 'ea0b',
  reactions_filled: 'ea0c',
  readchats: 'ea0d',
  recent: 'ea0e',
  redo: 'ea0f',
  replace: 'ea10',
  reply: 'ea11',
  reply_filled: 'ea12',
  restrict: 'ea13',
  revenue: 'ea14',
  rightpanel: 'ea15',
  rotate: 'ea16',
  rotate_left: 'ea17',
  rotate_right: 'ea18',
  round_chats_filled: 'ea19',
  saturation: 'ea1a',
  saved: 'ea1b',
  savedmessages: 'ea1c',
  schedule: 'ea1d',
  scheduled: 'ea1e',
  search: 'ea1f',
  select: 'ea20',
  send: 'ea21',
  send2: 'ea22',
  sending: 'ea23',
  sendingerror: 'ea24',
  settings: 'ea25',
  settings_clipped_corner: 'ea26',
  settings_filled: 'ea27',
  shadows: 'ea28',
  sharescreen_filled: 'ea29',
  sharpen: 'ea2a',
  shipping: 'ea2b',
  shuffle: 'ea2c',
  smallscreen: 'ea2d',
  smile: 'ea2e',
  speaker: 'ea2f',
  speakerfilled: 'ea30',
  speakeroff: 'ea31',
  speakerofffilled: 'ea32',
  spoiler: 'ea33',
  sport: 'ea34',
  star: 'ea35',
  star_filled: 'ea36',
  statistics: 'ea37',
  stickers: 'ea38',
  stickers_face: 'ea39',
  stop: 'ea3a',
  stories: 'ea3b',
  storyreply: 'ea3c',
  storyrepost: 'ea3d',
  strikethrough: 'ea3e',
  tag: 'ea3f',
  tag_add: 'ea40',
  tag_alt: 'ea41',
  tag_crossed: 'ea42',
  tag_filter: 'ea43',
  tag_name: 'ea44',
  text: 'ea45',
  textedit: 'ea46',
  timer: 'ea47',
  tip: 'ea48',
  tools: 'ea49',
  topics: 'ea4a',
  trade: 'ea4b',
  transcribe: 'ea4c',
  unarchive: 'ea4d',
  unclaimed: 'ea4e',
  underline: 'ea4f',
  undo: 'ea50',
  unmute: 'ea51',
  unpack: 'ea52',
  unpin: 'ea53',
  unread: 'ea54',
  up: 'ea55',
  user: 'ea56',
  username: 'ea57',
  videocamera: 'ea58',
  videocamera_crossed_filled: 'ea59',
  videocamera_filled: 'ea5a',
  videochat: 'ea5b',
  vignette: 'ea5c',
  volume_down: 'ea5d',
  volume_mute: 'ea5e',
  volume_off: 'ea5f',
  volume_up: 'ea60',
  warmth: 'ea61',
  webview: 'ea62',
  win_key: 'ea63',
  zoomin: 'ea64',
  zoomout: 'ea65'
};

export default Icons;
